import React, { createContext, useContext, useState } from "react";

const ShopContext = createContext(null);
export const useShop = () => useContext(ShopContext);

export const ShopProvider = ({ children }) => {
  const [searchOpen, setSearchOpen] = useState(false);
  return <ShopContext.Provider value={{ searchOpen, setSearchOpen }}>{children}</ShopContext.Provider>;
};
